import React from 'react'

export default function Footer() {
    return (
        <div>
            <footer class="site-footer">
                <div class="container">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <h6>About</h6>
                            <p class="text-justify">Trip Again (Pvt) Ltd is Pakistan based Travel & Tourism company ,We Operate From Karachi, We have Wise Experience in Travel & Tourism Industry, We believe in Clients Satisfaction.</p>
                        </div>

                        <div class="col-xs-6 col-md-3">
                            <h6>Categories</h6>
                            <ul class="footer-links">
                                <li><a href="#">Business Visa</a></li>
                                <li><a href="#">Job/Work Visa</a></li>
                                <li><a href="#">Student Visa</a></li>
                                <li><a href="#">Tourist Visa</a></li>
                                <li><a href="#">Dubai Visa</a></li>
                                <li><a href="#">Malaysia Visa</a></li>
                            </ul>
                        </div>

                        <div class="col-xs-6 col-md-3">
                            <h6>Quick Links</h6>
                            <ul class="footer-links">
                                <li><a href="#">About Us</a></li>
                                <li><a href="#">Contact Us</a></li>
                                <li><a href="#">Contribute</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="#">Sitemap</a></li>
                            </ul>
                        </div>
                    </div>
                    <hr/>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-sm-6 col-xs-12">
                            <p class="copyright-text">Copyright &copy; 2022 All Rights Reserved by
                                <a href="#">Trip Again</a>.
                            </p>
                            <p class="copyright-text">Site developed by: Ashar Ahmed
                                
                            </p>
                        </div>

                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <ul class="social-icons">
                                <li><a class="facebook" href="https://www.facebook.com/Trip-Again-Travel-Tours-119844183901361" target="blank"><i class="fa fa-facebook"></i></a></li>
                                <li><a class="twitter" href="#"><i class="fa fa-twitter"></i></a></li>
                                <li><a class="dribbble" href="#"><i class="fa fa-dribbble"></i></a></li>
                                <li><a class="linkedin" href="#"><i class="fa fa-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/footer.jsx